module.exports = __webpack_public_path__ + "media/images/avaka_logo-75de2650026e2c335c0d29b6164cf8f6.png";